"use client";
import {Card} from "@/components/ui/card";
import {FaCheck} from "react-icons/fa";
import CWFButton from "@/components/ui/CWFButton";
import * as yup from "yup";
import {useForm, useWatch} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {Tabs, TabsContent, TabsList, TabsTrigger} from "@/components/ui/tabs";
import {useState} from "react";
import PaymentSubscriptionButton from "@/app/tarifs/_components/PaymentSubscriptionButton";
const formSchema = yup.object({
    yearly : yup.boolean(),
})

export default function PricingCardSections({priceMockup,availablePlans}) {
    const form = useForm({
        resolver: yupResolver(formSchema),
    })
    const [yearlyPrice, setYearlyPrice] = useState(false);

    return (
        <section className={" py-5 md:py-10 px-10 md:px-20 bg-white"}>
            <h2 className={"text-center text-3xl md:text-[46px] font-bold"}>Choisis l&apos;abonnement qui <span
                className={"text-cwfLanding"}>évolue</span> avec toi</h2>
            <p className={"text-center pt-5"}>Essayer CWF-CoWorkFit pendant 30 jours annuler quand vous souhaitez</p>

            <Tabs defaultValue={"monthly"} className={"mt-5"}>
                <TabsList className={"grid grid-cols-2 gap-x-2 w-full md:w-1/3 h-[45px] mx-auto rounded-full "}>
                    <TabsTrigger
                        value={"monthly"}
                        onClick={() => setYearlyPrice(false)}
                        className={"rounded-full font-semibold  data-[state=active]:bg-cwfLanding data-[state=active]:text-white py-2"}
                    >
                        Mensuel
                    </TabsTrigger>
                    <TabsTrigger
                        value={"yearly"}
                        onClick={() => setYearlyPrice(true)}
                        className={"rounded-full font-semibold  data-[state=active]:bg-cwfLanding data-[state=active]:text-white py-2"}
                    >
                        Annuel (-20%)
                    </TabsTrigger>
                </TabsList>
                <TabsContent value={"monthly"}>
                    <div className={"grid md:grid-cols-3 gap-5 pt-8"}>
                        {priceMockup.map(function (price) {
                            return (
                                <div key={price.id} className={`${price.up ? 'relative mt-5 md:mt-0' : ''}`}>
                                    <Card
                                        className={`${price.up ? 'border-cwfLanding border-4' : 'border-black'} flex flex-col h-full`}>
                                        <div className="py-4 px-5 flex flex-col h-full">
                                            {/* Header section with fixed height */}
                                            <div className="h-32">
                                                <p className="font-bold pb-3">{price.name}</p>
                                                <p className="text-4xl font-semibold text-cwfLanding pl-2">
                                                    {yearlyPrice ? price.yearlyPrice : price.price}<span
                                                    className="text-sm">{price.price !== 'Gratuit' ? yearlyPrice ? '/an' : '/mois' : ''}</span>
                                                </p>
                                                <p className="text-sm pl-2">{price.price !== 'Gratuit' ? "ou " + (yearlyPrice ? price.price + "/mois" : price.yearlyPrice + "/an") : ""}</p>
                                            </div>

                                            {/* Separator at consistent height */}
                                            <hr className="border-black mb-5"/>

                                            <div className="mb-4">
                                                <p>Inclus :</p>
                                            </div>

                                            <div className="space-y-2 flex-grow">
                                                {price.includes.map(function (include, index) {
                                                    return (
                                                        <p key={index} className="flex gap-x-2 items-center">
                                                            <FaCheck className="text-cwfLanding"/>
                                                            {include}
                                                        </p>
                                                    )
                                                })}
                                            </div>

                                            <div className="mt-auto pt-5">
                                                {price.price !== 'Gratuit' && (
                                                    <PaymentSubscriptionButton label={"Choisir"} priceId={availablePlans.find(el => el.tier === price.tier).stripe_price_id} className={"w-full"}/>
                                                )}
                                                {/*<CWFButton className="w-full">Choisir</CWFButton>*/}
                                                <p className={"text-center text-xs italic pt-2"}>{price.intro}</p>
                                            </div>

                                        </div>
                                    </Card>
                                    {price.up && (
                                        <div
                                            className={"absolute bg-cwfLanding text-white font-semibold w-full -top-5 left-1/2 py-1 -translate-x-1/2 text-center rounded-t-xl"}>
                                            Le plus populaire
                                        </div>
                                    )}
                                </div>

                            )
                        })}
                    </div>
                </TabsContent>
                <TabsContent value={"yearly"}>
                    <div className={"grid md:grid-cols-3 gap-5 pt-8"}>
                        {priceMockup.map(function (price) {
                            return (
                                <div key={price.id} className={`${price.up ? 'relative mt-5 md:mt-0' : ''}`}>
                                    <Card
                                        className={`${price.up ? 'border-cwfLanding border-4' : 'border-black'} flex flex-col h-full`}>
                                        <div className="py-4 px-5 flex flex-col h-full">
                                            {/* Header section with fixed height */}
                                            <div className="h-32">
                                                <p className="font-bold pb-3">{price.name}</p>
                                                <p className="text-4xl font-semibold text-cwfLanding pl-2">
                                                    {yearlyPrice ? price.yearlyPrice : price.price}<span
                                                    className="text-sm">{price.price !== 'Gratuit' ? yearlyPrice ? '/an' : '/mois' : ''}</span>
                                                </p>
                                                <p className="text-sm pl-2">{price.price !== 'Gratuit' ? "ou " + (yearlyPrice ? price.price + "/mois" : price.yearlyPrice + "/an") : ""}</p>
                                            </div>

                                            {/* Separator at consistent height */}
                                            <hr className="border-black mb-5"/>

                                            <div className="mb-4">
                                                <p>Includes:</p>
                                            </div>

                                            <div className="space-y-2 flex-grow">
                                                {price.includes.map(function (include, index) {
                                                    return (
                                                        <p key={index} className="flex gap-x-2 items-center">
                                                            <FaCheck className="text-cwfLanding"/>
                                                            {include}
                                                        </p>
                                                    )
                                                })}
                                            </div>

                                            <div className="mt-auto pt-5">
                                                {price.price !== 'Gratuit' && (
                                                    <PaymentSubscriptionButton label={"Choisir"} priceId={availablePlans.find(el => el.tier === price.tier).stripe_yearly_price_id} className={"w-full"}/>
                                                )}
                                                <p className={"text-center text-xs italic pt-2"}>{price.intro}</p>
                                            </div>
                                        </div>
                                    </Card>
                                    {price.up && (
                                        <div
                                            className={"absolute bg-cwfLanding text-white font-semibold w-full -top-5 left-1/2 py-1 -translate-x-1/2 text-center rounded-t-xl"}>
                                            Le plus populaire
                                        </div>
                                    )}
                                </div>

                            )
                        })}
                    </div>
                </TabsContent>
            </Tabs>

        </section>
    );
}